/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

/**
 * Top padding for the content because we have a fixed header
 */
const siteHeader = document.querySelector('.site-header');
const siteBody = document.querySelector('.site-content');
const mobileNav = document.querySelector('.mobile-menu__nav');
let siteHeaderHeight;

document.addEventListener('DOMContentLoaded', () => {
  siteHeaderHeight = siteHeader.offsetHeight;
  siteBody.style.paddingTop = `${siteHeaderHeight}px`;
  //mobileNav.style.paddingTop = `${siteHeaderHeight}px`;
});

addEventListener('resize', (event) => {
  siteHeaderHeight = siteHeader.offsetHeight;
  siteBody.style.paddingTop = `${siteHeaderHeight}px`;
  //mobileNav.style.paddingTop = `${siteHeaderHeight}px`;
});

// Add external image to all target blank anchors
/*
document
  .querySelectorAll(
    ".entry__content a[target='_blank']:not(.wp-block-button__link)"
  )
  .forEach((e) => {
    console.log(e);
    // don't do with mailto links
    if (!e.href.includes('mailto')) {
      e.innerHTML +=
        "<img class='external-link' src='" +
        directory_uri.stylesheet_directory_uri +
        "/dist/images/external.svg' alt='" +
        x_screenReaderText.externalLink +
        "' />";
    }
  });

// in footer
document
  .querySelectorAll(".site-footer a[target='_blank']:not(.social-link)")
  .forEach((e) => {
    e.innerHTML +=
      "<img class='external-link' src='" +
      directory_uri.stylesheet_directory_uri +
      "/dist/images/external-white.svg' alt='" +
      x_screenReaderText.externalLink +
      "' />";
  });
  */
